module.exports = __webpack_public_path__ + "img/Antoinette-full.7cafa5da.png";